/**
 * Limites de caracteres e valores para validação no cliente.
 * Ajuste se a API documentar máximos diferentes.
 */
export const FORM_FIELD_LIMITS = {
  email: 100,
  passwordMin: 8,
  passwordMax: 128,
  fullName: 50,
  /** Nome de utilizador sem @; o campo de UI pode incluir @ — ver `usernameDisplay`. */
  username: 50,
  /** Campo com @ e margem para edição. */
  usernameDisplay: 56,
  wishlistTitle: 40,
  wishlistDescription: 100,
  productTitle: 100,
  productDescription: 300,
  productUrl: 2048,
  /** Input de preço formatado (ex.: "1.234,56"). */
  productPriceInput: 32,
  quantityMax: 9999,
  biography: 50,
} as const;
